import { SET_MENU_HISTORY } from './constants';

export const setMenuHistory = locations => {
    return {
        type: SET_MENU_HISTORY,
        payload: locations,
    };
};
